import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)
    const [ formOpeningMode, setFormOpeningMode ] = useState('EDITABLE')
    const [ loadingSubmitForm, setLoadingSubmitForm ] = useState(false)

    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,
        loadingSubmitForm, setLoadingSubmitForm
    })
}